module.exports = __webpack_public_path__ + "img/cszq_partners_6.fe235dec.jpg";